import React from 'react';

import { StripeStateProvider } from './stripeState';
import { StripePayment } from './organisms';

export function Stripe({
  user,
  amount,
  shippingAddress,
  createPayment,
  onPaymentConfirmed,
  currency = 'gbp',
  country = 'GB',
}) {
  return (
    <StripeStateProvider
      {...{
        user,
        amount,
        shippingAddress,
        createPayment,
        onPaymentConfirmed,
        currency,
        country
      }}
    >
      <StripePayment />
    </StripeStateProvider>
  );
}
